import { cn } from '~/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { listAllIssuesQueryOptions } from '~/queries'
import { useParams } from '@tanstack/react-router'
import { Badge } from '~/elements'

type Props = { className?: string; botId?: string; workspaceId?: string }

export const NotificationBadge = ({ botId, workspaceId, ...props }: Props) => {
  const params = useParams({ strict: false })

  botId = botId || params.botId
  workspaceId = workspaceId || params.workspaceId

  if (!botId || !workspaceId) {
    return null
  }

  return <InnerBadge workspaceId={workspaceId} botId={botId} {...props} />
}

type InnerBadgeProps = { className?: string; workspaceId: string; botId: string }
const InnerBadge = ({ className, workspaceId, botId, ...props }: InnerBadgeProps) => {
  const { data: issues } = useSuspenseQuery(listAllIssuesQueryOptions({ botId, workspaceId }))

  return issues.length > 0 ? (
    <Badge {...props} className={cn('border-none bg-red-50 text-red-600', className)}>
      <p className="text-xs">{issues.length}</p>
    </Badge>
  ) : null
}
